module.exports = "/assets/gift-events-listing/XMAS24-banner-comparison-desktop.png?A389Yr7";